import React, { useEffect, useRef, useState } from 'react'
import { Skeleton } from 'primereact/skeleton'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast'
import { Tag } from 'primereact/tag'
import moment from 'moment'
import { Button } from 'primereact/button'
import {
  formataCNPJ,
  formataCPF,
} from '../../components/utils/FormatacaoString'
import { removeDashesDotsAndSlashes } from '../../helpers/Replaces'
import Badge from '../../components/Badge/Badge'
import UsuarioServiceAPI from '../../service/UsuarioServiceAPI'
import { Calendar } from 'primereact/calendar'
import { SelectButton } from 'primereact/selectbutton'
import { InputText } from 'primereact/inputtext'
import InputMask from 'react-input-mask'
import {
  useLocation,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min'
import { Dropdown } from 'primereact/dropdown'
import { ConfirmDialog } from 'primereact/confirmdialog' // For <ConfirmDialog /> component
import { confirmDialog } from 'primereact/confirmdialog' // For confirmDialog method

export default function Boletos() {
  const [loading, setLoading] = useState(false)
  const [boletos, setBoletos] = useState([])

  const [dataInicio, setDataInicio] = useState(null)
  const [dataFinal, setDataFinal] = useState(null)
  const [nome, setNome] = useState('')
  const [documento, setDocumento] = useState('')
  const [statusBoleto, setStatusBoleto] = useState(null)
  const [selectedBoletos, setSelectedBoletos] = useState([])
  const [dataFast, setDataFast] = useState(null)

  const usuarioServiceApi = new UsuarioServiceAPI()

  const toast = useRef()
  const labelButtons = [
    { name: '7 dias', value: 7 },
    { name: '15 dias', value: 15 },
    { name: '30 dias', value: 30 },
  ]
  const statusBoletoOptions = [
    { name: 'Nenhum', value: null },
    { name: 'Executado', value: 0 },
    { name: 'Pendente', value: 1 },
    { name: 'Erro', value: 2 },
  ]

  const useQuery = () => {
    const { search } = useLocation()
    return new URLSearchParams(search)
  }

  const query = useQuery()

  const getBoletosSemFiltro = async () => {
    const idRemessa = query.get('idRemessa')

    let filtros = {
      nome: '',
      cpf: '',
      idRemessa: idRemessa ?? null,
      dataInicial: null,
      dataFinal: null,
      status: null,
    }

    setLoading(true)
    usuarioServiceApi
      .getRemessasFiltros(filtros)
      .then(({ data }) => {
        setBoletos(formatContratos(data))
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleReenviarBoleto = (idBoleto) => {
    setLoading(true)
    usuarioServiceApi
      .reenviarBoleto(idBoleto)
      .then(() => {
        toast.current.show({
          severity: 'success',
          summary: 'Sucesso!',
          detail: 'Boleto reenviado!',
          life: 3000,
        })
        getBoletosSemFiltro()
      })
      .catch((e) => {
        toast.current.show({
          severity: 'error',
          summary: 'Erro',
          detail: 'Houve um erro ao reenviar boleto!',
          life: 3000,
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleDownloadBoleto = (idBoleto) => {
    setLoading(true)
    usuarioServiceApi
      .downloadPdf(idBoleto)
      .then(() => {})
      .finally(() => {
        setLoading(false)
      })
  }

  const formatContratos = (ctts) => {
    let contratosFormatados = []
    ctts?.forEach((ctt) => {
      let obj = {
        ...ctt,
      }
      obj.dataEmissaoDate = ctt?.dataEmissaoDate
        ? moment(ctt?.dataEmissaoDate).format('DD/MM/YYYY')
        : ''
      obj.dataVencimento = ctt?.dataVencimento
        ? moment(ctt?.dataVencimento).format('DD/MM/YYYY')
        : ''
      obj.statusSTR =
        ctt?.statusSTR == 'Pendente' ? (
          <Badge cor='#212200' fundo='#ffc400' label='Pendente'></Badge>
        ) : ctt?.statusSTR == 'Executado' ? (
          <Badge cor='#ffffff' fundo='#00a11b' label='Executado'></Badge>
        ) : (
          <Badge cor='#ffffff' fundo='#bd0000' label='Erro ao enviar'></Badge>
        )
      obj.qtaNomeQta = (
        <div className='' style={{ maxWidth: 275 }}>
          <p
            style={{
              maxWidth: '100%',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
            }}
          >
            {ctt.qtaNomeQta}
          </p>
        </div>
      )
      obj.acoes = (
        <div className='flex' style={{ gap: 8 }}>
          <Button
            icon='pi pi-arrow-right'
            className='p-button p-button-info'
            label='Enviar segunda via'
            onClick={() => handleReenviarBoleto(ctt?.id)}
            loading={loading}
          />
          <Button
            icon='pi pi-download'
            className='p-button p-button-success'
            label='Download'
            onClick={() => handleDownloadBoleto(ctt.id)}
            loading={loading}
          />
        </div>
      )
      contratosFormatados.push(obj)
    })

    return contratosFormatados
  }

  const handleChangeLabelButton = (event) => {
    let getDataFinal = moment().toDate()
    let getDataInicial = moment()
      .subtract(event?.target?.value, 'days')
      .toDate()

    setDataFast(event?.target?.value)
    setDataFinal(getDataFinal)
    setDataInicio(getDataInicial)
  }

  const handleChangeDataInicio = (value) => {
    setDataFast(null)
    setDataInicio(value)
  }

  const handleChangeDataFinal = (value) => {
    setDataFast(null)
    setDataFinal(value)
  }

  const handleFilterRemessas = (e) => {
    e.preventDefault()

    const idRemessa = query.get('idRemessa')

    let filtros = {
      nome: nome,
      cpf: documento,
      idRemessa: idRemessa ?? null,
      dataInicial: dataInicio ? moment(dataInicio).format('YYYY-MM-DD') : null,
      dataFinal: dataFinal ? moment(dataFinal).format('YYYY-MM-DD') : null,
      status: statusBoleto ?? null,
    }

    setLoading(true)
    usuarioServiceApi
      .getRemessasFiltros(filtros)
      .then(({ data }) => {
        setBoletos(formatContratos(data))
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const acceptRemessaSegundaVia = () => {
    const dataRemessa = selectedBoletos?.map((b) => {
      return {
        id: b?.id,
      }
    })

    setLoading(true)
    usuarioServiceApi
      .reenviarRemessaBoleto(dataRemessa)
      .then(({ data }) => {
        toast.current.show({
          severity: 'success',
          summary: 'Confirmado',
          detail: 'Remessa enviada para todos os usuários',
          life: 3000,
        })
        setSelectedBoletos([])
        getBoletosSemFiltro()
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const rejectRemessaSegundaVia = () => {}

  const confirmarRemessaSegundaVia = () => {
    confirmDialog({
      message: `Tem certeza que deseja enviar segunda via para ${selectedBoletos?.length} usuários?`,
      header: 'Enviar segunda via em remessa',
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'accept',
      accept: acceptRemessaSegundaVia,
      reject: rejectRemessaSegundaVia,
      acceptLabel: 'Confirmar envio',
      rejectLabel: 'Cancelar',
    })
  }

  const limparFiltros = () => {
    setDataFast(null)
    setDataInicio(null)
    setDataFinal(null)
    setStatusBoleto(null)
    setDocumento('')
    setNome('')
  }

  useEffect(() => {
    // setLoading(true)
    // usuarioServiceApi
    //   .getRemessaBoleto()
    //   .then(({ data }) => {
    //     setBoletos(formatContratos(data))
    //   })
    //   .finally(() => {
    //     setLoading(false)
    //   })
    getBoletosSemFiltro()
  }, [])

  return (
    <div>
      <Toast ref={toast} />
      <ConfirmDialog />
      <h5 className='mb-4'>Filtrar Boletos</h5>

      <div className='grid'>
        <div className='card col-12'>
          <div className='col-12'>
            <SelectButton
              value={dataFast}
              onChange={(e) => handleChangeLabelButton(e)}
              optionLabel='name'
              options={labelButtons}
              className=''
              name='periodo'
            />
          </div>

          <div className='col-12'>
            <form method='POST' onSubmit={handleFilterRemessas} className=''>
              <div className='grid mt-2'>
                <div className='col-12 lg:col-2'>
                  <span className='p-input-icon-right block p-float-label mr-3'>
                    <i className='pi pi-calendar' />
                    <Calendar
                      style={{ width: '100%' }}
                      maxDate={dataFinal}
                      dateFormat='dd/mm/yy'
                      value={dataInicio}
                      onChange={(e) => handleChangeDataInicio(e.value)}
                    ></Calendar>
                    <label>Data de início</label>
                  </span>
                </div>
                <div className='col-12 lg:col-2'>
                  <span className='p-input-icon-right block p-float-label'>
                    <i className='pi pi-calendar' />
                    <Calendar
                      style={{ width: '100%' }}
                      minDate={dataInicio}
                      dateFormat='dd/mm/yy'
                      value={dataFinal}
                      onChange={(e) => handleChangeDataFinal(e.value)}
                    ></Calendar>
                    <label>Data final</label>
                  </span>
                </div>
              </div>
              <div className='grid mt-3'>
                <div className='col-12 lg:col-3'>
                  <span className='p-input-icon-right p-float-label w-full'>
                    <InputText
                      onChange={(e) => setNome(e?.target.value)}
                      value={nome}
                      name='nome'
                      className='w-full'
                    />
                    <label>Nome</label>
                  </span>
                </div>
                <div className='col-12 lg:col-3'>
                  <span className='p-input-icon-right p-float-label w-full'>
                    <InputMask
                      mask='999.999.999-99'
                      onChange={(e) => setDocumento(e.target.value)}
                      value={documento}
                      maskChar=''
                      noSpaceBetweenChars={true}
                    >
                      {(inputProps) => (
                        <InputText
                          id='inputCPFRef'
                          style={{ width: '100%' }}
                          type='text'
                        />
                      )}
                    </InputMask>
                    <label>CPF</label>
                  </span>
                </div>
                <div className='col-12 lg:col-3'>
                  <span className='p-input-icon-right p-float-label w-full'>
                    <Dropdown
                      name=''
                      value={statusBoleto}
                      onChange={(e) => setStatusBoleto(e?.target.value)}
                      options={statusBoletoOptions}
                      optionLabel='name'
                      optionValue='value'
                      className='w-full p-inputwrapper-filled'
                      checkmark={true}
                      highlightOnSelect={false}
                      // disabled
                    />
                    <label>Status boleto</label>
                  </span>
                </div>
              </div>
              <div
                className='flex justify-content-start align-items-center mt-3'
                style={{ gap: 8 }}
              >
                <Button
                  type='button'
                  icon='pi pi-times'
                  className='p-button p-button-danger'
                  label='Limpar filtros'
                  onClick={limparFiltros}
                />
                <Button
                  type='submit'
                  icon='pi pi-search'
                  label='Buscar boleto'
                />
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className='flex justify-content-between align-items-center mt-4'>
        <h5 className='mb-4'>Lista de Boletos</h5>
        <Button
          className='p-button p-button-success'
          disabled={selectedBoletos?.length < 2}
          label={`Enviar segunda via`}
          onClick={confirmarRemessaSegundaVia}
        />
      </div>
      <div className='grid mt-4'>
        <div className='card col-12'>
          {loading ? (
            <Skeleton height={300} />
          ) : (
            <DataTable
              value={boletos}
              responsiveLayout='scroll'
              emptyMessage='Nenhuma dado encontrado'
              dataKey='id'
              // selectionMode='checkbox'
              selection={selectedBoletos}
              onSelectionChange={(e) => setSelectedBoletos(e.value)}
            >
              <Column
                selectionMode='multiple'
                headerStyle={{ width: '3rem' }}
              ></Column>
              <Column
                className='white-space-nowrap'
                field='id'
                header='ID'
                style={{ width: '1%' }}
              />
              <Column
                className='white-space-nowrap'
                field='qtaNomeQta'
                header='Nome'
              />
              <Column
                className='white-space-nowrap'
                field='qtaDescrBem'
                header='Descrição BEM'
              />
              <Column
                className='white-space-nowrap'
                field='qtaNroParcela'
                header='N parcelas'
              />
              <Column
                className='white-space-nowrap'
                field='dataEmissaoDate'
                header='Emissão'
              />
              <Column
                className='white-space-nowrap'
                field='dataVencimento'
                header='Vencimento'
              />
              <Column
                className='white-space-nowrap'
                field='statusSTR'
                header='Status'
              />
              <Column
                className='white-space-nowrap'
                field='valorTotalFormatado'
                header='Valor boleto'
              />
              <Column
                className='white-space-nowrap'
                field='acoes'
                header='Ações'
              />
            </DataTable>
          )}
          {/* {loading ? (
            <Skeleton height={300} />
          ) : (
            <DataTable
              paginator
              rows={10}
              value={boletos}
              responsiveLayout='scroll'
              emptyMessage='Nenhum boleto encontrado'
              dataKey='id'
            >
              <Column
                field='numeroBoleto'
                header='Número do Boleto'
                style={{ whiteSpace: 'nowrap', width: 'auto' }}
              />
              <Column
                field='valor'
                header='Valor'
                body={valorBodyTemplate}
                style={{ whiteSpace: 'nowrap', width: 'auto' }}
              />
              <Column
                field='dataVencimento'
                header='Data de Vencimento'
                style={{ whiteSpace: 'nowrap', width: 'auto' }}
              />
              <Column
                field='dataPagamento'
                header='Data de Pagamento'
                body={dataPagamentoBodyTemplate}
                style={{ whiteSpace: 'nowrap', width: 'auto' }}
              />
              <Column
                field='status'
                header='Status'
                body={statusBodyTemplate}
                style={{ whiteSpace: 'nowrap', width: 'auto' }}
              />
              <Column
                field='beneficiario'
                header='Beneficiário'
                style={{ whiteSpace: 'nowrap', width: 'auto' }}
              />
              <Column
                field='pagador'
                header='Pagador'
                style={{ whiteSpace: 'nowrap', width: 'auto' }}
              />
              <Column
                field='codigoBarras'
                header='Código de Barras'
                style={{ whiteSpace: 'nowrap', width: 'auto' }}
              />
              <Column
                field='nossoNumero'
                header='Nosso Número'
                style={{ whiteSpace: 'nowrap', width: 'auto' }}
              />
              <Column
                field='banco'
                header='Banco'
                style={{ whiteSpace: 'nowrap', width: 'auto' }}
              />
              <Column
                field='agencia'
                header='Agência'
                style={{ whiteSpace: 'nowrap', width: 'auto' }}
              />
              <Column
                field='conta'
                header='Conta'
                style={{ whiteSpace: 'nowrap', width: 'auto' }}
              />
              <Column
                field='tipoBoleto'
                header='Tipo de Boleto'
                style={{ whiteSpace: 'nowrap', width: 'auto' }}
              />
              <Column
                field='instrucoes'
                header='Instruções'
                style={{ whiteSpace: 'nowrap', width: 'auto' }}
              />
            </DataTable>
          )} */}
        </div>
      </div>
    </div>
  )
}
